import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { FlatButton, Message } from "@evergis/ui";

import { ComplexConditionsContainer } from "../styled";

export const ComplexConditions: FC<{ toggleDevMode?: VoidFunction; clearConditions?: VoidFunction }> = ({
  toggleDevMode,
  clearConditions,
}) => {
  const { t } = useTranslation("layerFilter");

  return (
    <ComplexConditionsContainer>
      <Message success>{t("complexConditionMessage")}</Message>
      <FlatButton primary onClick={toggleDevMode}>
        {t("goProMode")}
      </FlatButton>
      <FlatButton onClick={clearConditions}>{t("doQueryRemove")}</FlatButton>
    </ComplexConditionsContainer>
  );
};
